<template>

<div>

  <LDBsTable
    url="maintance-reason"
    defaultSort="name"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-6">
      <label for="maintance_reason">{{ $t('maintance_reason') }}</label>
      <input
        type="text"
        id="maintance_reason"
        name="maintance_reason"
        class="form-control"
        :placeholder="$t('ph_maintance_reason')"
        v-model="query.name"
      >
    </div>

    <div class="form-group col-lg-6">
      <label for="isActive">{{ $t('active') }}</label>
      <vue-select
        class="bg-white"
        name='isActive'
        :placeholder="$t('select_a_item')"
        label="label"
        :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false } ]"
        v-model="query.isActive"
        :reduce="query => query.value"
        :select-on-tab='true'
      />
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'

export default {
  name: 'MaintanceReasonList',
  components: {
    LDBsTable
  },
  data () {
    return {
      columns: [
        {
          title: this.$t('name'),
          field: 'name',
          sortable: true
        },
        {
          title: this.$t('active'),
          field: 'isActive',
          formatter: function (value) {
            return value ? 'SIM' : 'NÃO'
          },
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/maintancereason/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'motivos_manutencao' }
      },
      query: {
        id: '',
        name: '',
        isActive: ''
      }
    }
  },
  methods: {
    clear() {
      this.query.name = '',
      this.query.isActive = ''
    }
  }
}
</script>
